import { createContext, useContext, useEffect, useState } from "react";
import {
  loadUserProjects,
  markProjectFavorite,
} from "../../api/userProjectsApi";
import { useDispatch, useSelector } from "react-redux";
import { resetState } from "../userProjectSlice";
import { setProjectOpen } from "../../layout/app-container/containerSlice";
import { serviceLines } from "../../utils/defaultValues";
import { getPddOpenProjectApi } from "../../utils/pddApiHelper";
import { useNavigate } from "react-router-dom";

export const UserDashBoardContext = createContext(undefined);
export const useUserDashBoardContextHook = () => {
  const context = useContext(UserDashBoardContext);

  if (context === undefined) {
    throw new Error("context should be used");
  }
  return context;
};

export const UserDashBoardContextProvider = ({ children }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const state = useSelector((state) => state.userprojects);
  const [projectList, setprojectList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dispatch(loadUserProjects());
  }, [dispatch]);

  useEffect(() => {
    if (!!state && state.list.length > 0) {
      // Set the project list without comment fetching for faster loading
      setprojectList(state.list);
      setLoading(false);
      dispatch(resetState());
    }
  }, [dispatch, state]);

  const markProjectFav = (p) => {
    dispatch(
      markProjectFavorite({ ...p, isFavoriteProject: !p.isFavoriteProject })
    );
  };

  const openProject = (data) => {
    const found = serviceLines.find(
      (f) => f.name.toLowerCase() === data.serviceLine.toLowerCase()
    );
    if (!!found) {
      // Use TDD API for PDD projects
      const apiEndpoint = getPddOpenProjectApi(found, data);
      
      dispatch(
        setProjectOpen({
          serviceLine: data.serviceLine.toLowerCase(),
          api: apiEndpoint,
          isProjectScope: true,
          projectIdent: data.projectIdent,
          isReadOnly: data.isReadOnly,
          projectName: data.projectName,
          currentProjectRole: "Default",
          projectLanguageCode: !!data.languageCode ? data.languageCode : "de",
        })
      );
      navigate(`${found.root}/project/project-dashboard`);
    }
  };
  
  return (
    <UserDashBoardContext.Provider
      value={{
        projectList: projectList, // Keep original variable name
        loading,
        setLoading,
        openProject,
        markProjectFav,
      }}
    >
      {children}
    </UserDashBoardContext.Provider>
  );
};